import { MoneyTrail } from '@/features/jobs/JobMoney'
import { useMemberWork, usePlayerPayments, useVoidPayment } from '@/lib/api/hooks'
import { WorkRows } from './WorkRows'

/**
 * A person's work record, as the staff panel reads it: every assignment they
 * hold with the job facts and the money words whole — the rate as terms even
 * when it is hidden from them, the working amount the crew editor holds — and
 * their money trail beside it. The same row shape the portal reads, before
 * its redaction.
 */
export function MemberWork({ memberId }: { memberId: string }) {
  const work = useMemberWork(memberId)
  const payments = usePlayerPayments(memberId)
  const voidPayment = useVoidPayment()

  if (work.isLoading) return <p className="py-2 text-caption text-muted-foreground">Reading the record…</p>
  if (work.error || !work.data) {
    return <p className="py-2 text-caption text-muted-foreground">The work record could not be read.</p>
  }

  return (
    <div className="-mx-3 mt-1 flex flex-col gap-4">
      <WorkRows rows={work.data.rows} staff emptyDetail="Assignments appear here the moment this person is crewed." />
      <section>
        <h4 className="text-micro mb-1 text-muted-foreground uppercase">Money trail</h4>
        <MoneyTrail
          payments={payments.data}
          loading={payments.isLoading}
          onVoid={({ id, reason }) => voidPayment.mutate({ id, reason })}
          voiding={voidPayment.isPending}
        />
      </section>
    </div>
  )
}
